import {
    Menu,
    MenuButton,
    MenuHeading,
    MenuItem,
    MenuItems,
    MenuSection,
    MenuSeparator,
} from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/24/outline";

/**
 * Bulk bar dropdown: trigger label + chevron, menu with heading, separator, and options (like catalog BulkEditBar).
 * Uses a portalled menu so it stacks above the table / sticky chrome.
 */
export function ProductCatalogBulkFieldMenu({
    triggerLabel,
    menuTitle,
    options = [],
    onSelect,
    disabled = false,
    tooltip,
    /** e.g. max-h-64 overflow-y-auto for long option lists */
    menuItemsClassName = "",
    menuWidthClassName = "w-40",
}) {
    return (
        <Menu as="div" className="relative inline-block text-left">
            <MenuButton
                type="button"
                disabled={disabled}
                title={tooltip}
                className="inline-flex h-7 items-center gap-1 rounded-md px-2.5 text-xs text-white/80 transition-colors hover:bg-white/10 hover:text-white disabled:cursor-not-allowed disabled:opacity-50"
            >
                <span>{triggerLabel}</span>
                <ChevronDownIcon className="h-3 w-3 shrink-0 opacity-60" aria-hidden />
            </MenuButton>

            <MenuItems
                portal
                modal={false}
                anchor={{ to: "bottom start", gap: "0.25rem", padding: "0.5rem" }}
                className={`z-[150] ${menuWidthClassName} origin-top-left rounded-md border border-gray-200 bg-white py-1 shadow-lg outline-none ${menuItemsClassName}`}
            >
                <MenuSection>
                    <MenuHeading className="px-3 py-1.5 font-medium text-xs">{menuTitle}</MenuHeading>
                    <MenuSeparator className="my-1 border-t border-gray-100" />
                    {options.map((opt) => (
                        <MenuItem key={String(opt.value)}>
                            <button
                                type="button"
                                className="block w-full cursor-pointer px-3 py-2 text-left text-sm text-primary hover:bg-gray-50 focus:outline-none data-[focus]:bg-gray-50"
                                onClick={() => onSelect?.(opt.value)}
                            >
                                {opt.label}
                            </button>
                        </MenuItem>
                    ))}
                </MenuSection>
            </MenuItems>
        </Menu>
    );
}

export default ProductCatalogBulkFieldMenu;
